import {http} from "../config/Constantes";
import axios from "axios";

export default class RelatorioService {
    constructor() {}

    findAuditoriaAcessoCrachaLiberacaoPeriodoMOT(filtro) {
        return http.post("/relatorios/auditoria-acesso-cracha-liberacao-periodo-mot", filtro);
    }

    downloadAuditoriaAcessoCrachaLiberacaoPeriodoMOTExcel(filtro) {
        return http.post("/relatorios/auditoria-acesso-cracha-liberacao-periodo-mot/xlsx", filtro, {responseType: 'blob'});
    }

    downloadAuditoriaAcessoCrachaLiberacaoPeriodoMOTPdf(filtro) {
        return http.post("/relatorios/auditoria-acesso-cracha-liberacao-periodo-mot/pdf", filtro, {responseType: 'blob'});
    }

    findAuditoriaAlocacaoMOT(filtro) {
        return http.post("/relatorios/auditoria-alocacao-mot", filtro);
    }

    downloadAuditoriaAlocacaoMOTExcel(filtro) {
        return http.post("/relatorios/auditoria-alocacao-mot/xlsx", filtro, {responseType: 'blob'});
    }

    downloadAuditoriaAlocacaoMOTPdf(filtro) {
        return http.post("/relatorios/auditoria-alocacao-mot/pdf", filtro, {responseType: 'blob'});
    }

    findAuditoriaSubstituicao(filtro) {
        return http.post("/relatorios/auditoria-substituicao", filtro);
    }

    downloadAuditoriaSubstituicaoExcel(filtro) {
        return http.post("/relatorios/auditoria-substituicao/xlsx", filtro, {responseType: 'blob'});
    }

    downloadAuditoriaSubstituicaoPdf(filtro) {
        return http.post("/relatorios/auditoria-substituicao/pdf", filtro, {responseType: 'blob'});
    }

    findFinanceiro(filtro) {
        return http.post("/relatorios/financeiro", filtro);
    }

    downloadFinanceiroExcel(filtro) {
        return http.post("/relatorios/financeiro/xlsx", filtro, {responseType: 'blob'});
    }

    downloadSolicitacaoExcel(filtro) {
        return http.post("/relatorios/solicitacao/xlsx", filtro, {responseType: 'blob'});
    }

    downloadTimesheetsPendentesExcel() {
        return http.post("/relatorios/timesheets-pendentes/xlsx", null, {responseType: 'blob'});
    }

    downloadMotsAtivasExcel(filtro) {
        return http.post("/relatorios/mots-ativas/xlsx", filtro, {responseType: 'blob'});
    }

    findProdutosAlteradosEBS(filtro) {
        return http.post("/relatorios/produtos-ebs", filtro);
    }

    downloadProdutosAlteradosEBSExcel(filtro) {
        return http.post("/relatorios/produtos-ebs/xlsx", filtro, {responseType: 'blob'});
    }
    downloadSisMotExcel(filtro) {
        return http.post("/relatorios/sis-mot/xlsx", filtro, {responseType: 'blob'});
    }

    downloadLotesPagamentoExcel(filtro) {
        return http.post("/relatorios/lotes-pagamento/xlsx", filtro, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    downloadMotsPorSindicatoExcel(filtro) {
        return http.post("/relatorios/mots-por-sindicato/xlsx", filtro, {responseType: 'blob'});
    }

}
